// Webrtc plugin.
import { getBrowserDetails } from '../selectors'

// Namespaced APIs.
import mediaAPI from './media'

import { logManager, API_LOG_TAG } from '../../../logs'

const log = logManager.getLogger('WEBRTC')

/**
 * Public API for the webRTC plugin.
 * @method api
 * @return {Object}
 */
export default function api (context) {
  return {
    media: mediaAPI(context),

    /**
     * Retrieve information about the browser being used.
     *
     * Browser information being defined indicates that the browser supports
     *    basic webRTC scenarios.
     * @public
     * @memberof api
     * @method getBrowserDetails
     * @return {Object} Object containing `browser` and `version` information.
     * @example
     * const details = client.getBrowserDetails()
     *
     * log(`Browser in use: ${details.browser}, version ${details.version}.`)
     */
    getBrowserDetails () {
      log.debug(API_LOG_TAG + 'getBrowserDetails')
      return getBrowserDetails(context.getState())
    }
  }
}
